import Campaign from '../store/Campaign';
import { beginLightning } from 'owa-lightning-core-v2';
import { setCampaignVisibility } from 'mini-campaign/lib/mutators/setCampaignVisibility';

const onLightUp = lightup => {
    // Immediately call the lightup because we do not need any lightning dependency here
    lightup();
};

/**
 * Function to start the lightning and set the campaign view state to true
 * @param campaign Campaign object
 */
export const startCampaign = <T extends {}>(campaign: Campaign<T>) => {
    beginLightning(campaign.getLightningId(), onLightUp);
    setCampaignVisibility(campaign, true);
};
